"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "volpedo": {
    "b4491b0f": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "ca-barbieri": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1df45a5": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "ca-di-stringa": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0419bd2": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0de4ce09": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "24947ede": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "551626ca": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "5ebffd4d": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "c32035f5": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "skipSearch": false
    }],
    "casanova": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cascina-cappelletta": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cascina-lago": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "strada-ghilina": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "strada-rovereto": [{
      "hkey": "f8daef6a",
      "slug": "volpedo",
      "name": "Volpedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;